import { IStringPromiseUnits, TStringPromiseResolve } from '@/models/promise-units.interface';

export default class PromiseHelper {
	public static createStringPromise(): IStringPromiseUnits {
		// Set initial value (so TypeScript understands it has the right type) which is always overwritten with the resolve function.
		let resolve = ((response: string) => {}) as TStringPromiseResolve; // eslint-disable-line
		// Create new Promise and store resolve function so it can be returned later.
		const promise: Promise<string> = new Promise((resolveFn) => (resolve = resolveFn as TStringPromiseResolve));
		// Return both the promise and resolve function.
		return { promise, resolve };
	}
}
